import { useEffect } from 'react'
import { ErrorBoundary } from '@/screens/workspace/w/workflow/components/error'

export default function WorkflowLayout({ children }: { children: React.ReactNode }) {
  // The toast stack is portalled to `<body>` and cannot tell it is over the
  // editor; `globals.css` keys its panel and terminal clearance on this.
  useEffect(() => {
    const root = document.documentElement
    root.setAttribute('data-workflow-page', '')
    return () => root.removeAttribute('data-workflow-page')
  }, [])

  return (
    <main className='flex h-full flex-1 flex-col overflow-hidden'>
      <ErrorBoundary>{children}</ErrorBoundary>
    </main>
  )
}
